var map = {
	"./begin.html": "5f0c",
	"./set1-1.html": "d6fe",
	"./set1-2.html": "0593",
	"./set1-3.html": "2f76",
	"./set1-4.html": "e576",
	"./set1-5.html": "e0db",
	"./set1-6.html": "2551",
	"./set1-7.html": "568e",
	"./set1-result1.html": "057d",
	"./set1-result2.html": "3b63",
	"./set1-result3.html": "5419",
	"./set2-1.html": "bc07",
	"./set2-2.html": "c901",
	"./set2-3.html": "fd3b",
	"./set2-4.html": "47c5",
	"./set2-5.html": "4906",
	"./set2-6.html": "17b9",
	"./set2-result1.html": "600e",
	"./set2-result2.html": "6fff",
	"./set2-result3.html": "d86c",
	"./thankyou.html": "d3df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c82d";